<template>
  <page-header-wrapper>
    <a-card :bordered="false">
      <!-- 条件搜索 -->
      <div class="table-page-search-wrapper">
        <a-form layout="inline">
          <a-row :gutter="48">
              <a-col :md="6" :sm="24">
                <a-form-item :label="$t('公式名称')" prop="name">
                  <a-input v-model="queryParam.name" :maxLength="32" :placeholder="$t('请输入')+$t('公式名称')" allow-clear/>
                </a-form-item>
              </a-col>
              <a-col :md="6" :sm="24">
                <a-form-item :label="$t('是否使用')" prop="isUse">
                  <a-select :placeholder="$t('请选择')+$t('是否使用')" style="width: 100%" v-model="queryParam.isUse" allowClear>
                    <a-select-option v-for="(item, index) in this.customDict.TFEnum" :value="item.type+''" :key="index">
                      {{ item.name }}
                    </a-select-option>
                  </a-select>
                </a-form-item>
              </a-col>
            <a-col :md="6" :sm="24">
              <a-form-item :label="$t('应用范围')" prop="scope">
                <a-select :placeholder="$t('请选择')+$t('应用范围')" style="width: 100%" v-model="queryParam.scope" allowClear>
                  <a-select-option v-for="(item, index) in this.customDict.GoodsFormulaScopeEnum" :value="item.type+''" :key="index">
                    {{ item.name }}
                  </a-select-option>
                </a-select>
              </a-form-item>
            </a-col>
              <a-col :md="6" :sm="24">
                <a-form-item :label="$t('创建开始时间')" prop="createBeginTime">
                  <a-date-picker style="width: 100%" v-model="queryParam.createBeginTime"
                     :show-time="{defaultValue: moment('00:00:00', 'HH:mm:ss')}"
                     valueFormat="YYYY-MM-DD HH:mm:ss" allow-clear/>
                </a-form-item>
              </a-col>
              <a-col :md="6" :sm="24">
                <a-form-item :label="$t('创建结束时间')" prop="createEndTime">
                  <a-date-picker style="width: 100%" v-model="queryParam.createEndTime"
                     :show-time="{defaultValue: moment('23:59:59', 'HH:mm:ss')}"
                     valueFormat="YYYY-MM-DD HH:mm:ss" allow-clear/>
                </a-form-item>
              </a-col>
            <a-col :md="6 || 24" :sm="24">
              <span class="table-page-search-submitButtons" :style="advanced && { float: 'right', overflow: 'hidden' } || {} ">
                <a-button type="primary" @click="handleQuery"><a-icon type="search" />{{$t('查询')}}</a-button>
                <a-button style="margin-left: 8px" @click="resetQuery"><a-icon type="redo" />{{$t('重置')}}</a-button>
              </span>
            </a-col>
          </a-row>
        </a-form>
      </div>
      <!-- 操作 -->
      <div class="table-operations">
        <a-button type="primary" @click="$refs.countStyle.open(queryParam.goodsId)" v-hasPermi="['goods:goodsformula:add']">
          <a-icon type="plus" />{{$t('新增')}}
        </a-button>
        <a-button type="danger" :disabled="multiple" @click="handleDelete" v-hasPermi="['goods:goodsformula:remove']">
          <a-icon type="delete" />{{$t('删除')}}
        </a-button>
        <a-button type="primary" @click="handleExport" v-hasPermi="['goods:goodsformula:export']">
          <a-icon type="download" />{{$t('导出')}}
        </a-button>
        <table-setting
          :style="{float: 'right'}"
          :table-size.sync="tableSize"
          v-model="columns"
          :refresh-loading="loading"
          @refresh="getList" />
      </div>
      <!-- 数据展示 -->
      <a-table
        v-table-sticky="{ fixedTop: 64 }"
        :scroll="{ x: 1200 }"
        :loading="loading"
        :size="tableSize"
        @change="handleSortChange"
        rowKey="id"
        :columns="columns"
        :data-source="list"
        :row-selection="{ selectedRowKeys: selectedRowKeys, onChange: onSelectChange }"
        :pagination="false"
        :bordered="tableBordered"
      >
        <span slot="createTime" slot-scope="text, record">
          {{ parseTime(record.createTime) }}
        </span>
        <div slot="scope" slot-scope="text, record">
          <a-select style="width: 50%" v-model="record.scope"  @change="onScopeChange(record)" v-if="record.scope===1">
            <a-select-option v-for="(item, index) in customDict.GoodsFormulaScopeEnum" :value="item.type" :key="index">
              {{ item.name }}
            </a-select-option>
          </a-select>
          <custom-dict-tag :options="customDict.GoodsFormulaScopeEnum" :value="record.scope" v-else/>
        </div>
        <div slot="supplierId" slot-scope="text, record">
          <a v-if="record.supplierName" @click="openSupplierSelect(record.supplierId,record.id)"> {{record.supplierName}}</a>
          <a v-else-if="!record.supplierName && record.scope === 4" @click="openSupplierSelect(record.supplierId,record.id)"> 选择供应商</a>
        </div>
        <span slot="isUse" slot-scope="text, record">
          <a-switch :disabled="record.scope===4" @change="(checked) => onUseChange(checked,record)" :checked-children="$t('是')" :un-checked-children="$t('否')" :checked="record.isUse"/>
        </span>
        <span slot="operation" slot-scope="text, record">
          <a-divider type="vertical" v-hasPermi="['goods:goodsformula:edit']" />
          <a @click="$refs.countStyle.updated(record)" v-hasPermi="['goods:goodsformula:edit']">
             <a-icon type="edit" />{{$t('修改')}}
          </a>
          <a-divider type="vertical" v-hasPermi="['goods:goodsformula:remove']" />
          <a @click="handleDelete(record)" v-hasPermi="['goods:goodsformula:remove']">
            <a-icon type="delete" />{{$t('删除')}}
          </a>
        </span>
      </a-table>
      <!-- 分页 -->
      <a-pagination
        class="ant-table-pagination"
        show-size-changer
        show-quick-jumper
        :pageSizeOptions="pageSizeOptions"
        :current="queryParam.pageNum"
        :total="total"
        :page-size="queryParam.pageSize"
        :showTotal="total => getTotal(total)"
        @showSizeChange="onShowSizeChange"
        @change="changeSize"
      />
      <CountStyle ref="countStyle" @ok="getList"></CountStyle>
      <supplier-radio-select ref="supplierRadioSelect" @supplierSelect="indexSupplierSelect"></supplier-radio-select>

    </a-card>
  </page-header-wrapper>
</template>

<script>
import {
  pageGoodsFormula,
  updateGoodsFormula,
  delGoodsFormula,
  updateGoodsFormulaUse,
  updateGoodsFormulaScope, updateGoodsFormulaSupplier
} from '@/api/goods/goodsFormula'
import {listSupplier,} from '@/api/supplier/supplier'
import CustomDictTag from "@/components/DictCustomTag";
import {mapGetters} from 'vuex'
import moment from 'moment';
import CountStyle from "./modules/CountStyle";
import { tableMixin } from '@/store/table-mixin'
import SupplierRadioSelect from '@/views/supplier/supplier/select/SupplierRadioSelect.vue'

export default {
  name: 'GoodsFormula',
  components: {
    CustomDictTag,
    CountStyle,
    SupplierRadioSelect
  },
  mixins: [tableMixin],
  data () {
    return {
      list: [],
      supplierList :[],
      pageSizeOptions: ['10', '20', '50', '100'],
      filteredInfo: {},
      sortedInfo : {},
      selectedRowKeys: [],
      selectedRows: [],
      //预览封面
      previewImageVisible: false,
      previewUrl: false,
      // 高级搜索 展开/关闭
      advanced: false,
      // 非单个禁用
      single: true,
      // 非多个禁用
      multiple: true,
      ids: [],
      loading: false,
      total: 0,
      goodsId: undefined,
      // 查询参数
      queryParam: {
        goodsId: undefined,
        formulaContent: undefined,
        name: undefined,
        scope: undefined,
        isUse: undefined,
        pageNum: 1,
        pageSize: 10
      },
      columns: [
        {
          title: '商品名称',
          dataIndex: 'goodsName',
          ellipsis: true,
          align: 'center'
        },
        {
          title: this.$t('公式内容'),
          dataIndex: 'formulaContentShow',
          ellipsis: true,
          align: 'center'
        },
        {
          title: this.$t('公式名称'),
          dataIndex: 'name',
          ellipsis: true,
          align: 'center'
        },
        {
          title: this.$t('应用范围'),
          dataIndex: 'scope',
          scopedSlots: { customRender: 'scope' },
          ellipsis: true,
          align: 'center'
        },
        {
          title: this.$t('是否使用'),
          dataIndex: 'isUse',
          scopedSlots: { customRender: 'isUse' },
          align: 'center'
        },
        {
          title: this.$t('创建时间'),
          dataIndex: 'createTime',
          scopedSlots: { customRender: 'createTime' },
          ellipsis: true,
          align: 'center'
        },
        {
          title: '供应商',
          dataIndex: 'supplierId',
          scopedSlots: { customRender: 'supplierId' },
          align: 'center'
        },
        {
          title: this.$t('操作'),
          dataIndex: 'operation',
          width: '18%',
          scopedSlots: { customRender: 'operation' },
          align: 'center'
        }
      ]
    }
  },
  filters: {
  },
  created () {
    this.getGoodsId()
    this.getList()
  },
  computed: {
    ...mapGetters(['customDict'])
  },
  watch: {
  },
  mounted() {
    this.getGoodsId()
  },
  methods: {
    moment,
    getTotal(total) {
      return this.$t('共')+total+this.$t('条')
    },
    /** 查询商品公式列表 */
    getList () {
      this.loading = true
      this.queryParam.goodsId = this.goodsId
     pageGoodsFormula(this.queryParam).then(response => {
        this.list = response.data.records
        this.total = response.data.total
        this.loading = false
      })
    },
    getGoodsId() {
      let goodsId = this.$route.query.goodsId;
      if (goodsId) {
        this.goodsId = goodsId;
        console.log('goodsId',this.queryParam.goodsId)
      }
    },
    getSupplierList() {
      listSupplier({}).then(response => {
        this.supplierList = response.data
      })
    },
    openSupplierSelect(supplierId, id) {
      this.$refs.supplierRadioSelect.openGoods(supplierId, id);
    },
    indexSupplierSelect(supplierId, id) {
      let data = {id:id, supplierId: supplierId}
      updateGoodsFormulaSupplier(data).then(response => {
        if (response.success) {
          this.$message.success(
            this.$t('修改成功'), 3);
        }
      }).finally(() => {
        this.getList()
        this.submitLoading = false
      })
    },
    /** 搜索按钮操作 */
    handleQuery () {
      this.queryParam.pageNum = 1
      this.getList()
    },
    /** 重置按钮操作 */
    resetQuery () {
      this.queryParam = {
        goodsId: undefined,
        formulaContent: undefined,
        name: undefined,
        scope: undefined,
        isUse: undefined,
        pageNum: 1,
        pageSize: 10
      }
      this.handleQuery()
    },
    handleSortChange(pagination, filters, sorter) {
      this.filteredInfo = filters
      this.sortedInfo = sorter
      if (sorter.order) {
        /** 排序字段 sortField **/
        /** 排序方式  sortOrder**/
        this.queryParam.sortField = sorter.columnKey
        if (this.queryParam.sortField==='createTime') {
          this.queryParam.sortField= 'id'
        }
        this.queryParam.sortOrder = sorter.order === 'ascend' ? 'asc' : 'desc'
        this.getList()
      } else {
        this.queryParam.sortField = '';
        this.queryParam.sortOrder = ''
        this.getList()
      }
    },
    onShowSizeChange (current, pageSize) {
      this.queryParam.pageSize = pageSize
      this.getList()
    },
    changeSize (current, pageSize) {
      this.queryParam.pageNum = current
      this.queryParam.pageSize = pageSize
      this.getList()
    },
    onSelectChange (selectedRowKeys, selectedRows) {
      this.selectedRowKeys = selectedRowKeys
      this.selectedRows = selectedRows
      this.ids = this.selectedRows.map(item => item.id)
      this.single = selectedRowKeys.length !== 1
      this.multiple = !selectedRowKeys.length
    },
    previewImageCancel() {
      this.previewImageVisible = false;
    },
    handleRecordPreview(url) {
      this.previewUrl = url
      this.previewImageVisible = true
    },
    toggleAdvanced () {
      this.advanced = !this.advanced
    },
    onUseChange(checked, record) {
      let data = {id:record.id, isUse: checked}
      updateGoodsFormulaUse(data).then(response => {
        if (response.success) {
          this.$message.success(
            this.$t('修改成功'),
            3
          );
          this.list.forEach(e=>{
            if (e.scope===1) {
              e.isUse=false;
            }
          })
          record.isUse=checked
        }
      }).finally(() => {
        this.submitLoading = false
      })
    },
    onScopeChange(record) {
      let data = {id:record.id, scope: record.scope}
      updateGoodsFormulaScope(data).then(response => {
        if (response.success) {
          this.$message.success(
            this.$t('修改成功'), 3);
          this.getList()
        }
      }).finally(() => {
        this.submitLoading = false
      })
    },
    onSupplierChange(record) {

    },
    /** 删除按钮操作 */
    handleDelete (row) {
      var that = this
      const ids = row.id || this.ids
      if(row.id){
        this.ids = []
        this.ids.push(row.id)
      }
      this.$confirm({
        title: this.$t('确认删除所选中数据'),
        onOk () {
          let data = []
          that.ids.map(id => data.push({"id":id}))
          return delGoodsFormula(data)
            .then(() => {
              that.onSelectChange([], [])
              that.getList()
              const message = that.$t('删除成功')
              that.$message.success(
                message,
                3
              )
          })
        },
        onCancel () {
          //取消清空删除ids列表
          that.ids = []
        }
      })
    },
    /** 导出按钮操作 */
    handleExport () {
      var that = this
      this.$confirm({
        title: this.$t('是否确认导出'),
        content: this.$t('此操作将导出当前条件下所有数据而非选中数据'),
        onOk () {
          that.download('biz/admin/goods/goods/formula/export',
            that.queryParam
          , `商品公式_${new Date().getTime()}.xlsx`)
        },
        onCancel () {}
      })
    }
  }
}
</script>
